import React from 'react';
import ResolveImage from 'components/ResolveImage';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import EmptyImg from 'assets/images/members.webp';

import './DataRoomNdasEmptyScreen.styles.scss';

type DataRoomNdasEmptyScreenProps = {
  className?: string;
};

const DataRoomNdasEmptyScreen: React.FC<DataRoomNdasEmptyScreenProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames(
    'data-room-ndas-empty-screen',
    'white-panel',
    className,
  );

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage src={EmptyImg} asIllustration alt="No ndas yet." />

      <p>{t('noNdasSignersAvailable')}</p>
    </div>
  );
};

export default DataRoomNdasEmptyScreen;
